import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-text font-weight-bold ms-1 mb-2" }
const _hoisted_2 = { class: "p-text font-weight-light ms-1 mb-2" }
const _hoisted_3 = { class: "p-text font-weight-bold ms-1 mb-2" }
const _hoisted_4 = { class: "position-relative" }
const _hoisted_5 = { class: "p-text font-weight-bold ms-1 mb-2" }
const _hoisted_6 = { class: "p-text font-weight-light ms-1 mb-2" }
const _hoisted_7 = { class: "p-text font-weight-bold ms-1 mb-2" }
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "p-text font-weight-bold ms-1 mb-2" }
const _hoisted_10 = { class: "p-text font-weight-light ms-1 mb-2" }
const _hoisted_11 = { class: "p-text font-weight-bold ms-1 mb-2" }

import {computed, reactive, ref, shallowRef, watch} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {useCartStore} from '@/api/store/cart';
import {productService} from '@/api/services/product';
import {servicesService} from '@/api/services/service';
import {packagesService} from '@/api/services/package';
import {useSettingsStore} from '@/api/store/settings';
import ButtonBase from "@/components/custom/ButtonBase.vue";
import ButtonFilterSelect from "@/components/custom/ButtonFilterSelect/ButtonFilterSelect.vue";
import debounce from 'lodash/debounce';
import SearchFilter from "@/components/custom/SearchFilter.vue";
import Icon from "@/components/Icons/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClinicIndex',
  setup(__props) {

const settingsStore = useSettingsStore();
const cartStore = useCartStore();

const router = useRouter();
const route = useRoute();

const category = route.params.category;

const loading = ref(false);

const state = reactive({
  items: [] as any[],
  search: "" as string,
  sort_asc: true as boolean,
  page: 1 as number,
});

const sortValues = [
  {
    name: 'asc',
    label: 'Asc'
  },
  {
    name: 'desc',
    label: 'Desc'
  }
]

const filterSelected = shallowRef('clear');

const sortTabSelectedValue = shallowRef({
  name: 'Sort',
  label: 'Sort'
})

const getFeaturedImage = (item: any) => {
  if (item.images.length > 0) {
    return item.images[0].full;
  }
  return '/img/placeholder.png';
}

const resetFilters = () => {
  state.search = "";
  state.sort_asc = true;
  filterSelected.value = 'clear';
  debouncedGetOrders();
}

// Computed
const filterQueryString = computed(() => {
  let filter = {
    sorting: '',
    search: state.search,
    searching: 'name'
  };

  let sortOrder = sortTabSelectedValue.value.name === 'Sort' ? 'desc' : sortTabSelectedValue.value.name;

  filter.sorting = `id,${sortOrder}`;

  return filter;
});

const loadItems = async () => {
  state.items = [];
  loading.value = true;

  try {
    if (!category || category === 'products') {
      await productService.index(null, filterQueryString.value).then((response) => {
        const data = response.data;
        data.forEach(function (element: any) {
          if (!element.visible_in_app) return;
          element.item_type = 'product';
          state.items.push(element);
        });
      });
      return;
    }

    if (!category || category === 'services') {
      await servicesService.index(filterQueryString.value).then((response) => {
        const data = response.data;
        data.forEach(function (element: any) {
          if (!element.client_visibility) return;
          element.item_type = 'service';
          state.items.push(element);
        });
      });
      return;
    }

    if (!category || category === 'packages') {
      await packagesService.index(filterQueryString.value).then((response) => {
        state.items = response.data.filter((element: any) => element.client_visibility);
      });
      return;
    }
  } finally {
    loading.value = false;
  }
}

const addProductToCart = (item: any) => {
  

  const supplierId = 0;
  const productId = item.id;
  const quantity = 1;
  let productType = undefined;

  if(item.item_type === "service") {
    productType = "App\\Models\\v3\\ClinicService"
  }

  if(item.type === "clinic_package") {
    productType ="App\\Models\\v3\\ClinicPackage"
  }

  cartStore.addItem(supplierId, productId, quantity, productType)
    .then(() => {
      router.push({ name: 'shopping-cart' });
    })
    .catch(() => {
      settingsStore.error = true;
      settingsStore.error_message = 
        "This item may be out of stock or no longer available from the supplier.";
    });
};


// Get total services for each package
const totalServicesFromPackage = (item: any) => {
  const servicesCount = item?.services.length ?? 0;

  return servicesCount > 1 ? `${servicesCount} services` : servicesCount === 0 ? `No services` : `${servicesCount} service`;
}

// Debounce the loadItems function
const debouncedGetOrders = debounce(loadItems, 300);

watch(() => [sortTabSelectedValue.value, state.search, filterSelected.value], () => {
  debouncedGetOrders();
});

loadItems();

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "px-1" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "my-0 py-1",
        "no-gutters": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "my-1",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(SearchFilter, {
                "model-value": state.search,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => state.search = val)
              }, null, 8, ["model-value"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "my-0 px-3",
            cols: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(ButtonFilterSelect, {
                modelValue: sortTabSelectedValue.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sortTabSelectedValue).value = $event)),
                "is-tab-selected": filterSelected.value === 'sort',
                items: sortValues,
                multiple: false,
                text: sortTabSelectedValue.value,
                icon: "sort-icon",
                "single-line": "",
                onClick: _cache[2] || (_cache[2] = ()=> filterSelected.value = 'sort')
              }, null, 8, ["modelValue", "is-tab-selected", "text"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "my-0 px-3",
            cols: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(ButtonBase, {
                "custom-class": ['transparent text-black', {'secondary-button text-white': filterSelected.value === 'clear'}],
                text: "Clear Filters",
                width: "100%",
                onClick: resetFilters
              }, null, 8, ["custom-class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (loading.value)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "px-2 mt-1",
            "no-gutters": ""
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
                return _createVNode(_component_v_col, {
                  key: n,
                  class: "pa-1",
                  cols: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "mx-auto pt-2 px-2",
                      height: "250"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_skeleton_loader, {
                          type: "image",
                          height: "123",
                          class: "mb-2"
                        }),
                        _createVNode(_component_v_skeleton_loader, {
                          type: "text",
                          class: "mb-1 mx-1"
                        }),
                        _createVNode(_component_v_skeleton_loader, {
                          type: "text",
                          width: "60%",
                          class: "mb-1 mx-1"
                        }),
                        _createVNode(_component_v_skeleton_loader, {
                          type: "text",
                          width: "40%",
                          class: "mx-1"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              }), 64))
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            class: "px-2 mt-1",
            "no-gutters": ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.items, (item) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: item.id,
                  class: "pa-1",
                  cols: "6"
                }, {
                  default: _withCtx(() => [
                    (item.item_type == 'product')
                      ? (_openBlock(), _createBlock(_component_v_card, {
                          key: 0,
                          class: "mx-auto pt-2 px-2",
                          height: "250",
                          onClick: ($event: any) => (_unref(router).push({ name: 'shop-product', params: { 
                  id: item.id, 
                  type: item.type === 'clinic_product'? 'clinic': 'natural-dispensary' 
                }
               }))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_img, {
                              src: getFeaturedImage(item),
                              class: "text-white text-right align-end",
                              cover: "",
                              height: "120"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  size: "40",
                                  variant: "flat",
                                  onClick: _withModifiers(($event: any) => (addProductToCart(item)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      color: _unref(settingsStore).settings.buttonColor,
                                      icon: "fa fa-cart-plus",
                                      size: "20"
                                    }, null, 8, ["color"])
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1032, ["src"]),
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, _toDisplayString(item.name), 1),
                                _createElementVNode("div", _hoisted_2, _toDisplayString(item.slot3), 1),
                                _createElementVNode("div", _hoisted_3, " £" + _toDisplayString(item.price.toFixed(2)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (item.item_type == 'service')
                        ? (_openBlock(), _createBlock(_component_v_card, {
                            key: 1,
                            class: "mx-auto pt-2 px-2",
                            height: "250",
                            onClick: ($event: any) => (_unref(router).push({ name: 'shop-service', params: { id: item.id } }))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_4, [
                                (item.image?.file?.file_path)
                                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                                      key: 0,
                                      class: "image-container m-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          style: _normalizeStyle({backgroundImage: `url(${item.image?.file?.file_path})`}),
                                          class: "image-container__image"
                                        }, null, 4)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_v_sheet, {
                                      key: 1,
                                      class: _normalizeClass([{'secondary-background-button-color': !item?.supplier }, "icon-container"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(Icon, { icon: "service-icon" })
                                      ]),
                                      _: 1
                                    }, 8, ["class"])),
                                _createVNode(_component_v_btn, {
                                  class: "service-and-products-button-cart",
                                  size: "40",
                                  variant: "flat",
                                  onClick: _withModifiers(($event: any) => (addProductToCart(item)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      color: _unref(settingsStore).settings.buttonColor,
                                      icon: "fa fa-cart-plus",
                                      size: "20"
                                    }, null, 8, ["color"])
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
                                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.booking_options ? item.booking_options.duration : '0') + " mins ", 1),
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.price_display), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (item.type == 'clinic_package')
                          ? (_openBlock(), _createBlock(_component_v_card, {
                              key: 2,
                              class: "mx-auto pt-2 px-2",
                              height: "250",
                              onClick: ($event: any) => (_unref(router).push({ name: 'shop-package', params: { id: item.id } }))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_8, [
                                  (item.image?.file?.file_path)
                                    ? (_openBlock(), _createBlock(_component_v_sheet, {
                                        key: 0,
                                        class: "image-container m-0"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", {
                                            style: _normalizeStyle({backgroundImage: `url(${item.image?.file?.file_path})`}),
                                            class: "image-container__image"
                                          }, null, 4)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : (_openBlock(), _createBlock(_component_v_sheet, {
                                        key: 1,
                                        class: _normalizeClass([{'secondary-background-button-color': !item?.supplier }, "icon-container"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(Icon, { icon: "service-icon" })
                                        ]),
                                        _: 1
                                      }, 8, ["class"])),
                                  _createVNode(_component_v_btn, {
                                    class: "service-and-products-button-cart",
                                    size: "40",
                                    variant: "flat",
                                    onClick: _withModifiers(($event: any) => (addProductToCart(item)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: _unref(settingsStore).settings.buttonColor,
                                        icon: "fa fa-cart-plus",
                                        size: "20"
                                      }, null, 8, ["color"])
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _createVNode(_component_v_card_text, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1),
                                    _createElementVNode("div", _hoisted_10, _toDisplayString(totalServicesFromPackage(item)), 1),
                                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.price_display), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}
}

})